/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Style_Preset_Default_NameInputs */

const en_image_export_style_preset_default_name = /** @type {(inputs: Image_Export_Style_Preset_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled`)
};

const fr_image_export_style_preset_default_name = /** @type {(inputs: Image_Export_Style_Preset_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sans titre`)
};

const de_image_export_style_preset_default_name = /** @type {(inputs: Image_Export_Style_Preset_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Titel`)
};

const it_image_export_style_preset_default_name = /** @type {(inputs: Image_Export_Style_Preset_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senza titolo`)
};

const ru_image_export_style_preset_default_name = /** @type {(inputs: Image_Export_Style_Preset_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Без названия`)
};

const es_image_export_style_preset_default_name = /** @type {(inputs: Image_Export_Style_Preset_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intitulado`)
};

const zh_cn2_image_export_style_preset_default_name = /** @type {(inputs: Image_Export_Style_Preset_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无题`)
};

const ja_image_export_style_preset_default_name = /** @type {(inputs: Image_Export_Style_Preset_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無題`)
};

const hi_image_export_style_preset_default_name = /** @type {(inputs: Image_Export_Style_Preset_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्षकहीन`)
};

const pt_pt2_image_export_style_preset_default_name = /** @type {(inputs: Image_Export_Style_Preset_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem título`)
};

/**
* | output |
* | --- |
* | "Untitled" |
*
* @param {Image_Export_Style_Preset_Default_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_style_preset_default_name = /** @type {((inputs?: Image_Export_Style_Preset_Default_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Style_Preset_Default_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_style_preset_default_name(inputs)
	if (locale === "de") return de_image_export_style_preset_default_name(inputs)
	if (locale === "it") return it_image_export_style_preset_default_name(inputs)
	if (locale === "ru") return ru_image_export_style_preset_default_name(inputs)
	if (locale === "es") return es_image_export_style_preset_default_name(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_style_preset_default_name(inputs)
	if (locale === "ja") return ja_image_export_style_preset_default_name(inputs)
	if (locale === "hi") return hi_image_export_style_preset_default_name(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_style_preset_default_name(inputs)
	return en_image_export_style_preset_default_name(inputs)
});